import { Heading, HeadingProps } from 'roo-ui/components';
import { useBookingListContext } from '../contextProvider/BookingListContextProvider';

type StylingProps = HeadingProps;

const BookingListHeading = (props: StylingProps) => {
  const { bookingListLabel } = useBookingListContext();

  return (
    <Heading data-testid="booking-list-heading" fontSize="28px" fontWeight="normal" mb={0} {...props}>
      {bookingListLabel}
    </Heading>
  );
};

export default BookingListHeading;
